import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/images/error-404.png")